import React, { ReactElement } from "react";
import ContainerRow from './ContainerRow';
import classnames from 'classnames';

let Styles: any;

try {
    Styles = require('./ButtonPair_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{
}

interface ButtonsProps {
    idNext: string,
    idPrevious: string,
    onClickNext: any,
    onClickBack: any,
    textoButtonNext: string,
    textoButtonBack: string,
    styleClass:string,
    minWidth?: string,
    maxWidth?: string,
    iconPrevious?: ReactElement,
    iconNext?: ReactElement,
    tabIndexPrevious?:number,
    tabIndexNext?:number
}
const Buttons: React.FC<ButtonsProps> = (props: ButtonsProps) => {
    const { idNext, idPrevious, onClickNext, styleClass, onClickBack, textoButtonNext,
            textoButtonBack, iconPrevious, iconNext, tabIndexPrevious,
            tabIndexNext, minWidth, maxWidth } = props;
  return (
    <ContainerRow>
      <div className="col-md-12 col-sm-6 col-xs-12 col-lg-6 pt-1">
        <button
          id={idPrevious}
          onClick={onClickBack}
          className={classnames(Styles.defaultButton, styleClass)}
          style={{ minWidth: minWidth, maxWidth: maxWidth }}
        >
          <table>
            <tr>
              <td className="pr-1">{iconPrevious}</td>
              <td>{textoButtonBack}</td>
            </tr>
          </table>
        </button>
      </div>
      <div className="col-md-12 col-sm-6 col-xs-12 col-lg-6 pt-1">
        <button id={idNext}
          onClick={onClickNext}
          className={classnames(Styles.defaultButton, styleClass)}
          style={{ minWidth: minWidth, maxWidth: maxWidth }}
        >
          <table>
            <tr>
              <td className="pr-1">{textoButtonNext}</td>
              <td>{iconNext}</td>
            </tr>
          </table>
        </button>
      </div>
    </ContainerRow>
  );
};

export default Buttons;